export default __webpack_public_path__ + "static/media/blueswirl.2426658e.svg";